<template>
  <v-flex md6
          offset-md3>
    <form v-on:submit.prevent="validate"
          class="spacing-top">
      <div class="sign-avatar">
        <router-link to="/">
          <img src="/static/img/logo.png"
               alt=""
               class="img-circle"></router-link>
      </div>
      <header v-html="$t('reset_title')"></header>
      <p v-html="$t('reset_tip')"></p>
      <div class="form-group">
        <api-select></api-select>
      </div>
      <v-text-field :label="$t('reset_placeholder')"
                    v-model="username"
                    type="email"
                    required
                    v-validate="{required: true, email: true}">
        <small class="text-danger">
          {{ errors.first('email') }}
        </small>
      </v-text-field>
      <v-container>
        <v-layout>
          <v-flex text-xs-right
                  xs12>
            <v-btn :to="{name: 'Login'}"
                   round
                   class="capitalize"
                   color="grey lighten-3">
              {{$t('login_button_back')}}
            </v-btn>
            <v-btn :loading="isLoading"
                   round
                   color="primary"
                   type="submit"
                   class="capitalize"
                   :disabled="isLoading">
              {{ $t('reset_button_send') }}
              <span slot="loader"
                    class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>

    </form>
  </v-flex>
</template>

<script>
import ApiSelect from './ApiSelect';
import { mapFields } from 'vee-validate';
import authService from '@/services/authService';
import store from '@/store';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'ForgotPassword',
  computed: {
    ...mapFields(['email'])
  },
  components: {
    [ApiSelect.name]: ApiSelect
  },
  data() {
    return {
      disabled: true,
      username: '',
      isLoading: false
    };
  },
  methods: {
    validate() {
      this.isLoading = true;
      this.$validator.validateAll().then(async res => {
        if (res) {
          var params = {
            username: this.username,
            lang: store.state.langSelected.langWsp
          };
          await authService.requestResetPassword(params, this.requestResetSuccessHandler, this.loginErrorHandler);
        }
      });
    },
    requestResetSuccessHandler(data) {
      this.isLoading = false;
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: data[0],
        type: 'accent',
        doNotTranslate: true
      });

      this.$router.push({ name: 'Login' });
    },
    loginErrorHandler(data) {
      this.isLoading = false;
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('error_generic'),
        type: 'error',
        doNotTranslate: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/login/ForgotPassword.vue